import React from "react";
import "../css/WhySpecial.css";
import asset from "../assets/images";
import { Link } from 'react-router-dom';

const WhySpecial = () => {
  return (
    <div className="why-special-container">
      {/* Left Section - Images */}
      <div className="why-special-images">
        <div className="image-overlay-container">
          <div className="image-wrapper image1-wrapper">
            <img src={asset.why6} alt="Camera 1" className="image" />
          </div>
          <div className="image-wrapper image2-wrapper">
            <img src={asset.why5} alt="Camera 2" className="image" />
          </div>
          <div className="image-wrapper image3-wrapper">
            <img src={asset.why4} alt="Camera 3" className="image" />
          </div>
        </div>
      </div>

      {/* Right Section - Content */}
      <div className="why-special-content">
        <h2 className="special-title">Why We Are Special</h2>
        <p className="special-description">
          At Priyantha Bandara Photography, we believe that every picture tells a story. With a passion for capturing emotions and a commitment to excellence, we transform fleeting moments into timeless memories.<br /><br />
          Our experience allows us to provide high-quality images that reflect the true essence of your special day. From portraits to celebrations, we offer both studio and on-location photography.<br /><br />
          Whether you're looking for elegantly posed shots or candid moments, we bring your memories to life with creativity and precision.
        </p>

        <div className="special-experience">
          <div className="experience-box">
            <span className="experience-number">10</span>
            <span className="experience-text">
              Years | Working | Experience
            </span>
          </div>
          <Link to="/about">
                        <button className="about-us-btn">About Us</button>
                      </Link>
        </div>
      </div>
    </div>
  );
};

export default WhySpecial;
